/**
 * 获取滚动条宽度
 * @returns {number}
 */
function getScrollbarWidth() {
  const container = document.createElement("div");
  document.body.appendChild(container);
  container.style.overflow = "scroll";
  const inner = document.createElement("div");
  container.appendChild(inner);
  const scrollbarWidth = container.offsetWidth - inner.offsetWidth;
  document.body.removeChild(container);
  return scrollbarWidth;
}

/**
 * @description 菜单下拉
 * @type {menuDropdown}
 */
// 全局 blur mask：挂在 body 最外层，脱离 sticky header 的合成层
function getHeaderBlurMask() {
  let mask = document.getElementById('header-blur-mask');
  if (!mask) {
    mask = document.createElement('div');
    mask.id = 'header-blur-mask';
    mask.style.cssText = [
      'position:fixed', 'left:0', 'width:100%', 'bottom:0',
      'background:rgba(0,0,0,0.5)',
      '-webkit-backdrop-filter:blur(10px)',
      'backdrop-filter:blur(10px)',
      'pointer-events:none',
      'display:none',
      'z-index:98'   /* 低于 sticky header 的 z-index:99，高于页面内容 */
    ].join(';');
    document.body.appendChild(mask);
  }
  return mask;
}

const menuDropdown = class extends HTMLElement {
  constructor() {
    super();
    // 处理子元素
    const dropdownMenu = this.querySelectorAll("li");
    const dropdownContent = this.querySelectorAll(".right-content .item");
    let activeIndex = 0;
    // 重置面板内的 sub-nav 过滤，还原显示所有系列
    const resetSubNavFilter = (panel) => {
      panel.querySelectorAll('.product-list__wrapper[data-sub-index]').forEach(w => {
        w.style.display = '';
      });
    };

    dropdownMenu.forEach((item, index) => {
      item.addEventListener("mouseover", () => {
        if (index < dropdownContent.length) {
          dropdownMenu[activeIndex].classList.remove("active");
          item.classList.add("active");
          dropdownContent[activeIndex].classList.remove("active");
          dropdownContent[index].classList.add("active");
          activeIndex = index;
          // 切换面板时重置 sub-nav 过滤和 active 状态
          item.querySelectorAll('.sub-nav-item').forEach(s => s.classList.remove('active'));
          resetSubNavFilter(dropdownContent[index]);
        }
      });

      // sub-nav 子项 hover：在当前面板内过滤显示对应系列
      item.querySelectorAll('.sub-nav-item').forEach(subItem => {
        subItem.addEventListener("mouseover", (e) => {
          e.stopPropagation();
          const targetIndex = subItem.dataset.subIndex;
          const panel = dropdownContent[activeIndex];
          panel.querySelectorAll('.product-list__wrapper[data-sub-index]').forEach(w => {
            const isTarget = w.dataset.subIndex === targetIndex;
            w.style.display = isTarget ? '' : 'none';
          });
          // sub-nav active 状态
          item.querySelectorAll('.sub-nav-item').forEach(s => s.classList.remove('active'));
          subItem.classList.add('active');
        });
      });
    });

    //监听父元素变化
    const parentNode = this.parentNode;
    parentNode.addEventListener("mouseleave", () => {
      if (dropdownMenu[activeIndex]) {
        dropdownMenu[activeIndex].classList.remove("active");
      }
      if (dropdownContent[activeIndex]) {
        dropdownContent[activeIndex].classList.remove("active");
      }
      if (dropdownMenu[0]) {
        dropdownMenu[0].classList.add("active");
      }
      if (dropdownContent[0]) {
        dropdownContent[0].classList.add("active");
      }
      activeIndex = 0;
      document.body.style.overflow = "";
      // 恢复body滚动
      document.body.classList.remove("no-scroll");
      document.documentElement.style.setProperty("--scrollbar-width", "17px");
      // 隐藏全局 blur mask
      const blurMask = document.getElementById('header-blur-mask');
      if (blurMask) blurMask.style.display = 'none';
    });

    // 获得焦点禁止body滚动
    parentNode.addEventListener("mouseover", () => {
      const scrollbarWidth = getScrollbarWidth();

      document.documentElement.style.setProperty(
        "--scrollbar-width",
        scrollbarWidth + "px",
      );
      document.body.classList.add("no-scroll");

      // 判断是否粘性
      const isStickyHeader = document.querySelector(
        ".components-header[header-sticky]",
      );
      if (isStickyHeader) {
        this.style.top = parentNode.getBoundingClientRect().bottom + "px";
      } else {
        this.style.top =
          parentNode.offsetTop +
          parentNode.offsetHeight -
          document.documentElement.scrollTop +
          "px";
      }

      // 显示全局 blur mask（body 最外层，脱离 sticky 合成层）
      const blurMask = getHeaderBlurMask();
      blurMask.style.top = this.style.top;
      blurMask.style.display = 'block';
    });

    // 鼠标失去焦点事件  需要的时候开启
    const mask = this.querySelector(".mask");
    mask.addEventListener("mouseover", () => {
      parentNode.style.pointerEvents = "none";
    });
    mask.addEventListener("mouseout", () => {
      setTimeout(() => {
        parentNode.style.pointerEvents = "auto";
      }, 300);
    });
  }

};
if (!window.customElements.get("menu-dropdown")) {
  window.customElements.define("menu-dropdown", menuDropdown);
}

// 监听菜单栏展开与关闭的操作
window.addEventListener("header-toggle", (e) => {
  const modelMenuBox = document.querySelector(".model-menu");
  if (e.detail.open) {
    document.body.classList.add("no-scroll");
    // 用 getBoundingClientRect 动态计算顶部位置，兼容粘性导航滚动后的偏移
    const headerBottom = modelMenuBox.parentNode.getBoundingClientRect().bottom;
    modelMenuBox.style.top = headerBottom + 'px';
    modelMenuBox.classList.add("active");
    // 重置内部滚动，防止 iOS 惯性滚动带入历史位置
    modelMenuBox.querySelector('.mob-menu-main')?.scrollTo(0, 0);
    modelMenuBox.querySelectorAll('.mob-sub-panel__content').forEach(el => el.scrollTo(0, 0));
  } else {
    document.body.classList.remove("no-scroll");
    // 先清 inline top，让 CSS top: -100% 生效并触发向上滑出动画
    modelMenuBox.style.top = '';
    modelMenuBox.classList.remove("active");
    // 关闭菜单时重置所有子面板
    closeMobSubPanels(modelMenuBox);
  }
});

// 移动端子面板：打开指定面板
function openMobSubPanel(menu, panelId) {
  const panel = menu.querySelector("#" + panelId);
  if (!panel) return;
  menu.classList.add("has-sub-panel");
  panel.classList.add("active");
}

// 移动端子面板：关闭所有面板，返回主列表
function closeMobSubPanels(menu) {
  menu.querySelectorAll(".mob-sub-panel.active").forEach(p => p.classList.remove("active"));
  menu.classList.remove("has-sub-panel");
}

window.addEventListener("DOMContentLoaded", () => {
  const menu = document.querySelector(".model-menu");
  if (!menu) return;

  // 一级菜单触发器点击 → 滑入子面板
  menu.addEventListener("click", (e) => {
    const trigger = e.target.closest(".mob-nav-trigger");
    if (trigger) {
      const panelId = trigger.dataset.mobPanel;
      openMobSubPanel(menu, panelId);
    }
  });

  // 返回按钮 → 退出子面板
  menu.addEventListener("click", (e) => {
    if (e.target.closest(".mob-back")) {
      closeMobSubPanels(menu);
    }
  });

  // Grid accordion 展开/收起：同级只开一个，打开时自动置顶
  menu.addEventListener("click", (e) => {
    const header = e.target.closest(".mob-accordion__header");
    if (!header) return;
    const accordion = header.closest(".mob-accordion");
    if (!accordion) return;

    const isOpen = accordion.classList.contains("open");

    // 关闭所有同级 accordion
    const parent = accordion.parentElement;
    parent.querySelectorAll(":scope > .mob-accordion.open").forEach(sibling => {
      sibling.classList.remove("open");
    });

    if (!isOpen) {
      accordion.classList.add("open");
      // 等 grid-template-rows 动画完成（300ms）后再滚动，此时兄弟项已收起、位置已稳定
      setTimeout(() => {
        const scrollContainer = accordion.closest(".mob-sub-panel__content");
        if (scrollContainer) {
          const headerRect = header.getBoundingClientRect();
          const containerRect = scrollContainer.getBoundingClientRect();
          const targetScrollTop = scrollContainer.scrollTop + (headerRect.top - containerRect.top) - 8;
          scrollContainer.scrollTo({ top: targetScrollTop, behavior: "smooth" });
        } else {
          header.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 300);
    }
  });
});

/**
 * 防抖函数
 * @param func
 * @param wait
 * @returns {(function(): void)|*}
 * @private
 */
function _debounce(func, wait) {
  let timeout;
  return function () {
    clearTimeout(timeout);
    timeout = setTimeout(func, wait);
  };
}

/**
 * 重置手风琴
 */
function resetAccordion() {
  const accordionAll = document.querySelectorAll(
    ".model-menu .accordion.group",
  );
  accordionAll.forEach((item) => {
    item.open = false;
  });
}

/**
 * 处理移动端菜单栏展开与关闭事件
 * @type {Element}
 */

const modelMenuOpenEl = document.querySelector(
  ".components-header .header-toggle .open",
);
const modelMenuCloseEl = document.querySelector(
  ".components-header .header-toggle .close",
);

if (modelMenuOpenEl && modelMenuCloseEl) {
  modelMenuOpenEl.addEventListener("click", () => {
    modelMenuOpenEl.classList.remove("active");
    modelMenuCloseEl.classList.add("active");
    window.dispatchEvent(
      new CustomEvent("header-toggle", { bubbles: true, detail: { open: true } }),
    );
  });

  modelMenuCloseEl.addEventListener("click", () => {
    modelMenuCloseEl.classList.remove("active");
    modelMenuOpenEl.classList.add("active");
    window.dispatchEvent(
      new CustomEvent("header-toggle", {
        bubbles: true,
        detail: { open: false },
      }),
    );
    resetAccordion();
  });
}

/**
 * 窗口大小变化时，判断是否需要关闭窗口
 */
function updateSizeDisplay() {
  // 响应式切换时始终隐藏 PC 端遮罩（mouseleave 在 resize 时不会触发）
  const blurMask = document.getElementById('header-blur-mask');
  if (blurMask) blurMask.style.display = 'none';

  if (window.innerWidth >= 1200) {
    if (modelMenuCloseEl && modelMenuCloseEl.classList.contains("active")) {
      modelMenuCloseEl.classList.remove("active");
      modelMenuOpenEl.classList.add("active");
      window.dispatchEvent(
        new CustomEvent("header-toggle", {
          bubbles: true,
          detail: { open: false },
        }),
      );
    }
  }
}

//处理窗口大小变化的问题
window.addEventListener("resize", _debounce(updateSizeDisplay, 100));

window.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".model-menu .product-list-scoll.swiper").forEach((el) => {
    new Swiper(el, {
      slidesPerView: "auto",
      spaceBetween: 8,
      observer: true,
      observeParents: true,
      navigation: {
        prevEl: el.querySelector(".swiper-button-prev"),
        nextEl: el.querySelector(".swiper-button-next"),
      },
      pagination: {
        el: el.querySelector(".swiper-pagination"),
        clickable: true,
      },
    });
  });

  // 监听手风琴的展开与关闭事件，只允许展开一个
  const accordionAll = document.querySelectorAll(
    ".model-menu .accordion__content .accordion.group",
  );
  accordionAll.forEach((item) => {
    item.addEventListener("toggle", () => {
      if (item.open) {
        accordionAll.forEach((subItem) => {
          if (subItem !== item) subItem.open = false;
        });
      }
    });
  });

  // 外层 accordion 展开时自动打开第一个内层
  document.querySelectorAll(".model-menu-wrapper > .accordion.group > summary").forEach((summary) => {
    summary.addEventListener("click", () => {
      const outer = summary.closest(".accordion.group");
      setTimeout(() => {
        if (!outer.open) return;
        const firstInner = outer.querySelector(".accordion__content .accordion.group");
        if (firstInner && !firstInner.open) firstInner.open = true;
      }, 0);
    });
  });

  // 产品卡片放大镜 hover 效果
  document.querySelectorAll(
    ".components-header .menu-dropdown-content .product-item .image",
  ).forEach((item) => {
    const magnifier = item.querySelector(".magnifier");
    if (magnifier) {
      item.addEventListener("mousemove", () => magnifier.classList.add("show"));
      item.addEventListener("mouseleave", () => magnifier.classList.remove("show"));
    }
  });

  // 站点选择显示关闭
  const marketDrawer = document.querySelector("we-drawer#navigation-market-drawer");
  const marketBtn = document.querySelector("#navigation-market-btn");
  const marketMobBtn = document.querySelector("#navigation-market-mob-btn");
  if (marketBtn && marketDrawer) marketBtn.addEventListener("click", () => marketDrawer.open());
  if (marketMobBtn && marketDrawer) marketMobBtn.addEventListener("click", () => marketDrawer.open());
});

window.customElements.get("menu-dropdown-link") ||
  window.customElements.define(
    "menu-dropdown-link",
    class extends HTMLElement {
      connectedCallback() {
        const parentNode = this.parentNode;

        parentNode.addEventListener("mouseover", () => {
          const bottom = parentNode.getBoundingClientRect().bottom;
          parentNode.style.setProperty("--top", `${bottom}px`);
          document.documentElement.style.setProperty("--scrollbar-width", getScrollbarWidth() + "px");
          document.body.classList.add("no-scroll");
          // 显示全局 blur mask
          const blurMask = getHeaderBlurMask();
          blurMask.style.top = (bottom + 1) + 'px';
          blurMask.style.display = 'block';
        });

        parentNode.addEventListener("mouseleave", () => {
          document.body.classList.remove("no-scroll");
          document.documentElement.style.setProperty("--scrollbar-width", "17px");
          // 隐藏全局 blur mask
          const blurMask = document.getElementById('header-blur-mask');
          if (blurMask) blurMask.style.display = 'none';
        });

        const mask = this.querySelector(".mask");
        mask.addEventListener("mouseover", () => {
          parentNode.style.pointerEvents = "none";
        });
        mask.addEventListener("mouseout", () => {
          setTimeout(() => {
            parentNode.style.pointerEvents = "auto";
          }, 300);
        });
      }
    },
  );

